var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"show-tag-columns":true,"show-tag-filter":true,"single-actions":_vm.singleActions,"group-actions":_vm.groupActions,"showSearchbox":_vm.showSearchbox,"showGroupActions":_vm.showGroupActions,"export-data-options":_vm.exportDataOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }